import '../../node_modules/slick-carousel/slick/slick.js';


jQuery( document ).ready(function() {

    $('.myslider').slick({
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        prevArrow: $('.customprev'),
        nextArrow: $('.customnext'),

        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
        });

});